class PopupWrapper extends HTMLElement{
    constructor() {
        super();
    }
    
    connectedCallback() {
        const skuInput = this.querySelector('#sku');
        const productNameInput = this.querySelector('#product_name');
        const variantSelect = this.querySelector('#variant-select');
        const fileInput = this.querySelector('#upload-icon');
        const registerButton = this.querySelector('button[type="submit"]');
        
        const skuContainer = this.querySelector('.input__product__sku');
        const productNameContainer = this.querySelector('.input__product__name');
        const uploadContainer = this.querySelector('.input__product__upload');
        const formErrors = this.querySelector('.form__errors');

        // SKU Validation
        skuInput.addEventListener('blur', () => {
            const skuValue = skuInput.value;
            if (skuValue.length === 10 && /^\d+$/.test(skuValue)) {
                skuContainer.classList.add('valid');
                skuContainer.classList.remove('invalid');
                formErrors.textContent = '';
                this.checkEnableVariantSelect();
            } else {
                skuContainer.classList.add('invalid');
                skuContainer.classList.remove('valid');
                formErrors.textContent = 'Wrong SKU Code, It should be a 10 digit number';
            }
        });

        // Product Name Validation
        productNameInput.addEventListener('blur', () => {
            const nameValue = productNameInput.value.trim();
            if (nameValue.replace(/\s/g, '').length > 7) {
                productNameContainer.classList.add('valid');
                productNameContainer.classList.remove('invalid');
                formErrors.textContent = '';
                this.checkEnableVariantSelect();
            } else {
                productNameContainer.classList.add('invalid');
                productNameContainer.classList.remove('valid');
                formErrors.textContent = 'Product name should be more than 7 characters';
            }
        });

        // Variant Select Change
        variantSelect.addEventListener('change', () => {
            if (variantSelect.value !== 'Select capacity/variant') {
                fileInput.disabled = false;
                this.checkEnableRegisterButton();
            }
        });

        // File Input Change
        fileInput.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (file) {
                const fileSize = file.size / (1024 * 1024); // Convert to MB
                if (fileSize > 20) {
                    uploadContainer.classList.add('invalid');
                    formErrors.textContent = 'File size exceeds above 5 MB';
                    fileInput.value = ''; // Clear the file input
                } else {
                    uploadContainer.classList.remove('invalid');
                    formErrors.textContent = '';
                    this.checkEnableRegisterButton();
                }
            }
        });
    }

    // Helper method to check and enable variant select
    checkEnableVariantSelect() {
        const skuContainer = this.querySelector('.input__product__sku');
        const productNameContainer = this.querySelector('.input__product__name');
        const variantSelect = this.querySelector('#variant-select');

        if (skuContainer.classList.contains('valid') && 
            productNameContainer.classList.contains('valid')) {
            variantSelect.disabled = false;
        }
    }

    // Helper method to check and enable register button
    checkEnableRegisterButton() {
        const skuContainer = this.querySelector('.input__product__sku');
        const productNameContainer = this.querySelector('.input__product__name');
        const variantSelect = this.querySelector('#variant-select');
        const fileInput = this.querySelector('#upload-icon');
        const registerButton = this.querySelector('button[type="submit"]');

        if (skuContainer.classList.contains('valid') && 
            productNameContainer.classList.contains('valid') && 
            variantSelect.value !== 'Select capacity/variant' && 
            fileInput.files.length > 0) {
            registerButton.disabled = false;
        }
    }
}

customElements.define("popup-wrapper", PopupWrapper)